import getDisplayBytes from '@shootsta/get-display-bytes';

function getBytes(bytes) {
  if (Number.isNaN(Number(bytes))) {return '0';}

  return getDisplayBytes(bytes);
}

export default function getUploadProgress(
loadedBytes,
totalBytes,
loadedPercent)
{
  if (loadedPercent === 100) {return 'Complete';}

  if (loadedPercent === 99) {return 'Finalising';}

  return `${getBytes(loadedBytes)} / ${getBytes(totalBytes)}`;
}